<template>
<div id="LineLogin" class="">
  <b-container fluid>
    <b-row>
      <!-- <b-col md="4" class="text-white bg-dark">2 of 2</b-col> -->
      <b-col md="7" lg="5" class="form-login mx-auto mb-3">
        <b-card class="mb-1 animate__animated animate__fadeIn" footer-class="text-center">
          <b-card-body class="text-center align-items-center h2">
            <b-img :src="profile.pictureUrl" width="100px" class="rounded-circle"></b-img>
            <br />
            <h3>ยินดีต้อนรับ</h3>
            คุณ {{ profile.displayName }}
          </b-card-body>

          <b-card-body>

            <div class="text-center" v-if="!dataReady">
              <b-spinner style="width: 3rem; height: 3rem;" label="Loading..." variant="info"></b-spinner>
            </div>
            <b-form @submit="loginUser" v-if="dataReady">
              <b-card-text>
                <label for="form_username" class="mb-1">Username:</label>
                <b-form-input id="form_username" required autocomplete="off" class="mb-2" v-model="form.userName" type="text" ></b-form-input>
                <label for="form_password" class="mb-1">Password:</label>
                <b-form-input id="form_password" required autocomplete="off" class="mb-2" v-model="form.password" type="password"></b-form-input>
              </b-card-text>
              <!-- <b-button variant="success" @click="loginUser" block pill>Log in</b-button> -->
              <b-button variant="success" type="submit" block pill>Log in</b-button>
            </b-form>
          </b-card-body>
          <!-- <template #footer>
            <b-button href="#" variant="primary">Register</b-button>
          </template> -->
        </b-card>
        <br>
        <b-button variant="primary" pill @click="registerUser" block>Create an account</b-button>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'LineLogin',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    this.$liff.init({ liffId: '1656919687-VmAj6j0p' }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.$session.destroy()

    await this.$liff.ready.then(async () => {
      if (process.env.NODE_ENV === 'development') {

      } else {
        if (!this.$liff.isLoggedIn()) {
          this.$liff.login({ redirectUri: window.location })
        } else {
          await this.getLineProfile()
        }
      }
    })

    // if (!this.$liff.isLoggedIn()) {
    //   this.$liff.login({ redirectUri: window.location })
    // } else {

    // }

    // localStorage.removeItem('memberData')
    // await this.getDataUser("tester")
  },
  data () {
    return {
      msg: 'Welcome Kathin',
      dataReady: true,
      profile: {
        userId: "",
        displayName: "กำลังดึงข้อมูล",
        pictureUrl: "https://rodpremium.com/assets/loader.gif"
      },
      form: {
        userName: '',
        password: ''
      }
    }
  },
  methods: {
    async getLineProfile () {
      this.dataReady = false
      let _this = this
      await this.$liff.getProfile().then(async (profileLine) => {
        // console.log(profileLine)
        _this.profile = profileLine
        this.dataReady = true
        this.getLineLogin(profileLine)
      })
      .catch((err) => {
        console.log('Getting profile error:', err);

      })
    },
    getLineLogin (profileLine) {
      // console.log("profileLineID : ", profileLine.userId)
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Sys_line/profile?userLineId="+profileLine.userId,
          {
            headers: this.getHeaderAPI('Profile', profileLine.userId)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            this.$router.push('/oa/profile')
          } else {
            console.log("ผิดพลาด", "ไม่สามารถดึงข้อมูลส่วนตัวได้", "error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log("ผิดพลาด","ไม่สามารถดึงข้อมูลส่วนตัวได้", error)
          this.dataReady = true;
          // this.errored = true
        })
    },
    loginUser () {
      // let _this = this
      this.dataReady = false
      let urlAuthen = "https://licm-cargo.com/api/Authen/login"
      axios
        .post(
          // eslint-disable-next-line quotes
          urlAuthen,
          this.form,
          {
            headers: this.getHeaderAPI('Login', this.form.userName)
            // headers: this.headerAPI
          }
        )
        .then(async (response) => {
          // console.log('loginUser', response)
          let rs = response.data
          if (rs.status === true) {
            // this.$swal("เข้าระบบสำเร็จ")

            let fullName = rs.firstName + " " + rs.lastName
            this.dataReady = true

            this.lineConnect(fullName)
          } else {
            console.log('loginUser Fail')
            this.$swal("ไม่สามารถเข้าระบบได้", rs.message, "error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          // console.log(error)
          this.$swal("ERROR", "ไม่สามารถเข้าระบบได้ : "+ error, "error")
          // alert(error)
          // this.loginUser("http://licm-cargo.com/api/Authen/login")
          this.dataReady = true
        })
    },
    lineConnect (fullName) {
      // let _this = this
      this.dataReady = false
      // let urlAuthen = "https://licm-cargo.com/api/Authen/login"
      let dataLine = {
        userName: this.form.userName,
        displayName: fullName,
        userLineId: this.profile.userId
      }
      console.log("ข้อมูล LINE" ,dataLine)
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Sys_line/login_line",
          dataLine,
          {
            headers: this.getHeaderAPI('Login_line', this.form.userName)
            // headers: { 'application-key' : 'T2FLZ#Xo:!WJ%qnC+jPf(U&EkHDi_K8V*S(QKb)!Rcqd6XI8pOyl_unZWN2PS,E*1r=f*eL7E:4%;6y@I.)$!P_xHCnh,q3AKU#tap' }

          }
        )
        .then(async (response) => {
          // console.log('loginUser', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("ลงทะเบียน LINE สำเร็จ")

            this.$router.push('/oa/profile')
          } else {
            console.log('loginUser Fail')
            this.$swal("ไม่สามารถลงทะเบียน LINE ได้", "error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          // console.log(error)
          this.$swal("ERROR", "ไม่สามารถลงทะเบียน LINE ได้ : "+ error, "error")
          // alert(error)
          // this.loginUser("http://licm-cargo.com/api/Authen/login")
          this.dataReady = true
        })
    },

    registerUser () {
      this.$router.push('/oa/register')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 60px;
}
label{
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/LineOA/LineLogin.vue